export const ReferencesConfig = {
  name: "references",
  references: [
    {
      clientName: "Mapfre",
      personName: "",
      logo: "mapfre.png"
    },
    {
      clientName: "Bankia",
      personName: "",
      logo: "bankia.svg"
    },
    {
      clientName: "Rabobank",
      personName: "",
      logo: "rabobank-logo.png"
    }
  ]
};

export default ReferencesConfig;



// WEBPACK FOOTER //
// ./src/containers/references/ReferencesConfig.js